import * as React from 'react';
import Home from 'containers/HomeContainer';
import UnsupportedBrowser from 'components/UnsupportedBrowser';
import LoadingSpinner from './LoadingSpinner';
import * as intl from 'react-intl-universal';
import * as bowser from 'bowser';

// locale data
const locales = {
  'en-US': require('assets/locales/en-US.json'),
  'cs-CZ': require('assets/locales/cs-CZ.json'),
  'de-DE': require('assets/locales/de-DE.json'),
  'es-ES': require('assets/locales/es-ES.json'),
  'fi-FI': require('assets/locales/fi-FI.json'),
  'fr-FR': require('assets/locales/fr-FR.json'),
  'it-IT': require('assets/locales/it-IT.json'),
  'ja-JP': require('assets/locales/ja-JP.json'),
  'ko-KR': require('assets/locales/ko-KR.json'),
  'nl-NL': require('assets/locales/nl-NL.json'),
  'no-NO': require('assets/locales/no-NO.json'),
  'pl-PL': require('assets/locales/pl-PL.json'),
  'pt-BR': require('assets/locales/pt-BR.json'),
  'sv-SE': require('assets/locales/sv-SE.json'),
  'zh-CN': require('assets/locales/zh-CN.json'),
};

const localeDataUrl = process.env.REACT_APP_LOCALE_DATA;
const commonLocaleDataUrls = {
  'cs': `${localeDataUrl}en.js`,
  'de': `${localeDataUrl}de.js`,
  'en': `${localeDataUrl}en.js`,
  'es': `${localeDataUrl}es.js`,
  'fi': `${localeDataUrl}en.js`,
  'fr': `${localeDataUrl}fr.js`,
  'it': `${localeDataUrl}it.js`,
  'ja': `${localeDataUrl}ja.js`,
  'ko': `${localeDataUrl}ko.js`,
  'nl': `${localeDataUrl}nl.js`,
  'no': `${localeDataUrl}en.js`,
  'pl': `${localeDataUrl}pl.js`,
  'pt': `${localeDataUrl}pt.js`,
  'sv': `${localeDataUrl}sv.js`,
  'zh': `${localeDataUrl}zh.js`
};

export interface Props {
  currentLocale: string;
}

interface State {
  initDone: boolean;
  isValidBrowser: boolean;
}

class Layout extends React.PureComponent<Props, State>{
  constructor(props: any) {
    super(props);

    const browser = bowser.getParser(window.navigator.userAgent);
    const isValidBrowser = browser.satisfies({ chrome: '>66.0.3359' });

    this.state = { initDone: false, isValidBrowser };
  }

  componentDidMount() {
    this.loadLocales();
  }

  loadLocales() {
    // init method will load CLDR locale data according to currentLocale
    // react-intl-universal is singleton, so you should init it only once in your app
    let currentLocale = this.props.currentLocale;
    if (!(currentLocale in locales)) {
      currentLocale = 'en-US';
    }
    intl.init({
      currentLocale,
      locales,
      commonLocaleDataUrls,
    })
    .then(() => {
      // After loading CLDR locale data, start to render
      this.setState({ initDone: true });
    });
  }

  render() {
    if (!this.state.initDone) {
      return <LoadingSpinner />;
    }
    if (this.state.isValidBrowser) {
      return <Home />;
    }
    return (
      <UnsupportedBrowser />
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout.tsx